import * as z from "zod";
import { carrierClaimsFilterSchema } from "./carrier-claims-analytics-common";

export const carrierClaimsFunnelSchema = z.object({
  created: z.number(),
  submitted: z.number(),
  submittedDateUnknown: z.number(),
  redoApproved: z.number(),
  decided: z.number(),
  approved: z.number(),
  rejected: z.number(),
  refunded: z.number(),
});
export type CarrierClaimsFunnel = z.infer<typeof carrierClaimsFunnelSchema>;

export const carrierClaimsRevenueSchema = z.object({
  refundedClaims: z.number(),
  redoKeepRevenueUsd: z.number(),
  payoutRetainedUsd: z.number(),
  carrierPayoutUsd: z.number(),
  merchantPayoutUsd: z.number(),
});
export type CarrierClaimsRevenue = z.infer<typeof carrierClaimsRevenueSchema>;

export const getCarrierClaimsSummary = {
  name: "getCarrierClaimsSummary" as const,
  input: carrierClaimsFilterSchema,
  output: z.object({
    funnel: z.object({
      current: carrierClaimsFunnelSchema,
      prior: carrierClaimsFunnelSchema,
    }),
    revenue: z.object({
      current: carrierClaimsRevenueSchema,
      prior: carrierClaimsRevenueSchema,
    }),
  }),
};

export type GetCarrierClaimsSummaryOutput = z.infer<
  typeof getCarrierClaimsSummary.output
>;
